export const ic_host = "https://icp0.io";
